import { FetchUtil } from "../util/FetchUtil";
import { IEndpoint } from "../models/IEndpoint";
import { WyanokeUtil } from "../util/WyanokeUtil";

interface IRecommendedResponse {
  readonly cards: string;
}

export class RecommendedService {
  private _currentMyRecoPromise:
    Promise<IRecommendedResponse | null> | null = null;

  constructor(private readonly _endpoint: IEndpoint) {
  }

  public async getReco(viewname:string): Promise<IRecommendedResponse | null> {
    const cachedPromise = this._currentMyRecoPromise;

    return cachedPromise ?
      cachedPromise :
      this._currentMyRecoPromise = this.load(viewname);
  }

  public async load(viewname:string): Promise<IRecommendedResponse | null> {
    let result: IRecommendedResponse = {
      cards:  ""
    };

    const endpoint = this._endpoint;
    if (!endpoint) {
      console.error("Could not resolve endpoint in recommended service");

      return result;
    }

    const activityid = window.Activity ? window.Activity.Id || "" : "";

    const profile = await WyanokeUtil.loadUserProfile(true, false);

    if (!profile || !profile.contactid) {
      console.error("Could not resolve user in recommended service");

      return result;
    }

    const url = endpoint.url + "?activityid="
      + activityid + "&sitename=healiotwo&contactid="
      + profile.contactid + "&view=" + viewname;

      let raw;
      try{
        raw = await FetchUtil.sendMessage({
          method: endpoint.method,
          url
        });
      } catch{
        raw = undefined;
      }

    if (typeof raw !== "object") {
      const msg = "Unexpected response from server";
      console.error(msg, raw);

      return result;
    }

    const response = raw as IRecommendedResponse;

    result = {
      cards: response.cards || ""
    };

    return result;
  }

}
